export default "__VITE_ASSET__d40227be__"